/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:22bd5697-e336-485e-9764-b13412e6ca6a",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_pTk62thB7",
    "aws_user_pools_web_client_id": "6lambdh2qbss7jbnl9f1ngmb27",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "apiAskChatGpt",
            "endpoint": "https://wko2ca34z0.execute-api.eu-west-1.amazonaws.com/dev",
            "region": "eu-west-1"
        }
    ],
    "aws_content_delivery_bucket": "amplifyvoice-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://dn9mcnfiy88j.cloudfront.net",
    "aws_user_files_s3_bucket": "amplify-chatgpt-documents222215-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "predictions": {
        "convert": {
            "transcription": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "language": "en-GB"
                }
            },
            "speechGenerator": {
                "region": "eu-west-1",
                "proxy": false,
                "defaults": {
                    "VoiceId": "Kevin",
                    "LanguageCode": "en-US"
                }
            }
        }
    }
};


export default awsmobile;
